document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.faq-tabs__nav-btn');
    const panels = document.querySelectorAll('.faq-tabs__panel');

    tabs.forEach((btn) => {
        btn.addEventListener('click', function () {
            const tabId = this.dataset.tab;

            document.querySelectorAll('.faq-tabs__nav-item').forEach((item) => item.classList.remove('is-active'));
            panels.forEach((panel) => panel.classList.remove('is-active'));

            this.parentElement.classList.add('is-active');
            document.querySelector(`.faq-tabs__panel[data-tab="${tabId}"]`).classList.add('is-active');
        });
    });
});
